import { put, takeLatest, all, select, fork } from 'redux-saga/effects';
import { API_URL } from 'containers/App/constants';
import { getRequestHeadersAsLogged, responseHandler } from '../../utils/auth';
import { STORE_CHILD_OFFER, DELETE_CHILD_OFFER, UPDATE_CHILD_OFFER } from './constants'
import { makeSelectIsLoading } from './selectors'
import { makeSelectOfferCode } from 'containers/CatalogEdit/selectors'
import {
  addChildOffer,
  removeChildOffer,
  setLoading,
  unsetEditMode,
  setErrorMsg,
  replaceChildOffer
} from './actions'

function* storeChildToOffer({offer}) {
  const isLoading = yield select(makeSelectIsLoading());

  if (!isLoading) {
    yield put(setLoading(true));

    const parentCode = yield select(makeSelectOfferCode());

    const requestURL = `${API_URL}offers/${parentCode}/child`;

    try {
      const parameters = {
        method: 'POST',
        headers: getRequestHeadersAsLogged(),
        body: JSON.stringify({ ...offer }),
      };

      const response = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );

      if (response.data.child) {
        const {
          deposit,
          duration,
          distance,
          monthly_rate,
          web_monthly_rate,
          id: ref
        } = response.data.child

        yield put(addChildOffer({
          deposit,
          duration,
          distance,
          monthly_rate,
          web_monthly_rate,
          ref
        }));
      } else {
        yield put(setErrorMsg(response.data.errors));
      }
    } catch (e) {
      console.log('error', e);
    }
  }
}

function* updateChildOffer({id, data}) {
  const isLoading = yield select(makeSelectIsLoading());

  if (!isLoading) {
    yield put(setLoading(true));

    const parentCode = yield select(makeSelectOfferCode());

    const requestURL = `${API_URL}offers/${parentCode}/child/${id}`;

    const body = JSON.stringify({
      deposit: data.newDeposit,
      duration: data.newDuration,
      distance: data.newDistance,
      monthly_rate: data.newMonthlyRate,
    })

    try {
      const parameters = {
        method: 'PUT',
        headers: getRequestHeadersAsLogged(),
        body,
      };

      const response = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );

      yield put(replaceChildOffer(response.data));
      yield put(unsetEditMode());

    } catch (e) {
      console.log('error', e);
    }
  }
}

function* deleteChildToOffer({id}) {
  const isLoading = yield select(makeSelectIsLoading());

  if (!isLoading) {
    yield put(setLoading(true));

    const parentCode = yield select(makeSelectOfferCode());

    const requestURL = `${API_URL}offers/${parentCode}/child/${id}`;

    try {
      const parameters = {
        method: 'DELETE',
        headers: getRequestHeadersAsLogged(),
      };

      const response = yield fetch(requestURL, parameters).then(response =>
        responseHandler(response)
      );
      yield put(removeChildOffer(id));
    } catch (e) {
      console.log('error', e);
    }
  }
}

function* actionWatcher() {
  yield takeLatest(STORE_CHILD_OFFER, storeChildToOffer);
  yield takeLatest(DELETE_CHILD_OFFER, deleteChildToOffer);
  yield fork(takeLatest, UPDATE_CHILD_OFFER, updateChildOffer);
}

export default function* catalogEditData() {
  yield all([actionWatcher()]);
}
